export const tsData = [
    [1262304000000, 0.7537],
    [1262563200000, 0.6951],
    [1262649600000, 0.6925],
    [1262736000000, 0.697],
    [1262822400000, 0.6992],
    [1262908800000, 0.7007],
    [1263168000000, 0.6884],
    [1263254400000, 0.6907],
    [1263340800000, 0.6868],
    [1263427200000, 0.6904],
    [1263513600000, 0.6958],
    [1263772800000, 0.696],
    [1263859200000, 0.7004],
    [1263945600000, 0.7077],
    [1264032000000, 0.7111],
    [1264118400000, 0.7076],
    [1264377600000, 0.7068],
    [1264464000000, 0.7101],
    [1264550400000, 0.7107],
    [1264636800000, 0.7144],
    [1264723200000, 0.7161],
    [1264982400000, 0.7189],
    [1265068800000, 0.7176],
    [1265155200000, 0.7152],
    [1265241600000, 0.7223],
    [1265328000000, 0.7305],
    [1265587200000, 0.7314],
    [1265673600000, 0.7268],
    [1265760000000, 0.7279],
    [1265846400000, 0.7291],
    [1265932800000, 0.7369],
    [1266192000000, 0.735],
    [1266278400000, 0.7328],
    [1266364800000, 0.7286],
    [1266451200000, 0.7372],
    [1266537600000, 0.7398],
    [1266796800000, 0.734],
    [1266883200000, 0.7366],
    [1266969600000, 0.7383],
    [1267056000000, 0.7414],
    [1267142400000, 0.737],
    [1267401600000, 0.7395],
    [1267488000000, 0.7382],
    [1267574400000, 0.7332],
    [1267660800000, 0.7317],
    [1267747200000, 0.7364],
    [1268006400000, 0.7321],
    [1268092800000, 0.7377],
    [1268179200000, 0.7349],
    [1268265600000, 0.7323],
    [1268352000000, 0.7266],
    [1268611200000, 0.7298],
    [1268697600000, 0.7288],
    [1268784000000, 0.7271],
    [1268870400000, 0.7322],
    [1268956800000, 0.7382],
    [1269216000000, 0.7424],
    [1269302400000, 0.7398],
    [1269388800000, 0.7498],
    [1269475200000, 0.7488],
    [1269561600000, 0.749],
    [1269820800000, 0.7424],
    [1269907200000, 0.7418],
    [1269993600000, 0.742],
    [1270080000000, 0.7426],
    [1270166400000, 0.7426],
    [1270425600000, 0.7426],
    [1270512000000, 0.7466],
    [1270598400000, 0.7497],
    [1270684800000, 0.7522],
    [1270771200000, 0.7473],
    [1271030400000, 0.7362],
    [1271116800000, 0.7363],
    [1271203200000, 0.7346],
    [1271289600000, 0.7384],
    [1271376000000, 0.7389],
    [1271635200000, 0.7446],
    [1271721600000, 0.7416],
    [1271808000000, 0.7479],
    [1271894400000, 0.7498],
    [1271980800000, 0.7514],
    [1272240000000, 0.7508],
    [1272326400000, 0.7525],
    [1272412800000, 0.7551],
    [1272499200000, 0.7545],
    [1272585600000, 0.7511],
    [1272844800000, 0.7555],
    [1272931200000, 0.7641],
    [1273017600000, 0.7739],
    [1273104000000, 0.7858],
    [1273190400000, 0.7847],
    [1273449600000, 0.7712],
    [1273536000000, 0.7876],
    [1273622400000, 0.7884],
    [1273708800000, 0.7946],
    [1273795200000, 0.8006],
    [1274054400000, 0.8099],
    [1274140800000, 0.8047],
    [1274227200000, 0.8151],
    [1274313600000, 0.8109],
    [1274400000000, 0.8003],
    [1274659200000, 0.8092],
    [1274745600000, 0.8182],
    [1274832000000, 0.8125],
    [1274918400000, 0.8161],
    [1275004800000, 0.8076],
    [1275264000000, 0.8126],
    [1275350400000, 0.8228],
    [1275436800000, 0.8186],
    [1275523200000, 0.8152],
    [1275609600000, 0.8293],
    [1275868800000, 0.8363],
    [1275955200000, 0.8375],
    [1276041600000, 0.8327],
    [1276128000000, 0.8303],
    [1276214400000, 0.8247],
    [1276473600000, 0.8165],
    [1276560000000, 0.8159],
    [1276646400000, 0.8146],
    [1276732800000, 0.809],
    [1276819200000, 0.8084],
    [1277078400000, 0.8071],
    [1277164800000, 0.8159],
    [1277251200000, 0.815],
    [1277337600000, 0.8156],
    [1277424000000, 0.8135],
    [1277683200000, 0.8105],
    [1277769600000, 0.8199],
    [1277856000000, 0.815],
    [1277942400000, 0.8113],
    [1278028800000, 0.797],
    [1278288000000, 0.7981],
    [1278374400000, 0.7951],
    [1278460800000, 0.7958],
    [1278547200000, 0.79],
    [1278633600000, 0.7914],
    [1278892800000, 0.7955],
    [1278979200000, 0.7957],
    [1279065600000, 0.7873],
    [1279152000000, 0.7796],
    [1279238400000, 0.7693],
    [1279497600000, 0.7719],
    [1279584000000, 0.7787],
    [1279670400000, 0.7803],
    [1279756800000, 0.7783],
    [1279843200000, 0.7755],
    [1280102400000, 0.7734],
    [1280188800000, 0.7674],
    [1280275200000, 0.7698],
    [1280361600000, 0.7653],
    [1280448000000, 0.7677],
    [1280707200000, 0.765],
    [1280793600000, 0.7565],
    [1280880000000, 0.7573],
    [1280966400000, 0.7586],
    [1281052800000, 0.7591],
    [1281312000000, 0.7546],
    [1281398400000, 0.7615],
    [1281484800000, 0.7684],
    [1281571200000, 0.782],
    [1281657600000, 0.7814],
    [1281916800000, 0.7801],
    [1282003200000, 0.7777],
    [1282089600000, 0.7765],
    [1282176000000, 0.7792],
    [1282262400000, 0.7868],
    [1282521600000, 0.7873],
    [1282608000000, 0.7931],
    [1282694400000, 0.7929],
    [1282780800000, 0.7879],
    [1282867200000, 0.7867],
    [1283126400000, 0.7875],
    [1283212800000, 0.7887],
    [1283299200000, 0.7814],
    [1283385600000, 0.7803],
    [1283472000000, 0.7793],
    [1283731200000, 0.7769],
    [1283817600000, 0.7848],
    [1283904000000, 0.7877],
    [1283990400000, 0.7866],
    [1284076800000, 0.786],
    [1284336000000, 0.7813],
    [1284422400000, 0.7783],
    [1284508800000, 0.77],
    [1284595200000, 0.7647],
    [1284681600000, 0.7658],
    [1284940800000, 0.765],
    [1285027200000, 0.7623],
    [1285113600000, 0.7484],
    [1285200000000, 0.7507],
    [1285286400000, 0.7457],
    [1285545600000, 0.7421],
    [1285632000000, 0.743],
    [1285718400000, 0.7348],
    [1285804800000, 0.7328],
    [1285891200000, 0.7286],
    [1286150400000, 0.7298],
    [1286236800000, 0.7258],
    [1286323200000, 0.7218],
];